export const filterPdfFiles = (files) => {
  return files.filter((f) => f.type === 'application/pdf');
};

export const filterXmlFiles = (files) => {
  return files.filter(
    (f) => f.type === 'text/xml' || f.name.toLowerCase().endsWith('.xml')
  );
};

export const filterAcceptedFiles = (files) => {
  return Array.from(files).filter(
    (f) =>
      f.type === 'application/pdf' ||
      f.type === 'text/xml' ||
      f.name.toLowerCase().endsWith('.xml')
  );
};

export const createDocumentEntry = (file) => ({
  id: Date.now() + Math.random(),
  filename: file.name,
  status: 'uploading',
  file,
  classificationData: null,
  downloadUrl: null,
});
